"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCancelWithdrawal = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var useCancelWithdrawal = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction;
    var _c = (0, useMutation_1.useMutation)({
        successAction: successAction,
        path: keys_1.WITHDRAWAL_CANCEL,
        keysUpdate: [
            keys_1.BALANCE,
            keys_1.TRANSACTIONS,
            keys_1.PROFILE_TRANSACTIONS_HISTORY,
            keys_1.PENDING_WITHDRAWALS,
        ],
    }), mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error;
    return (0, react_1.useMemo)(function () { return ({
        cancelWithdrawal: mutate,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [mutate, isSubmitting, error]);
};
exports.useCancelWithdrawal = useCancelWithdrawal;
